import { WorkoutPlanCategory, WorkoutPlanType } from 'types/workouts';

export const getIsWorkoutDone = (category: string, completion_id: number | null) =>
    category === WorkoutPlanCategory.Completed && typeof completion_id === 'number';

export const getSortedPlan = (plan: WorkoutPlanType[]) =>
    [...plan].sort(
        (a, b) =>
            Number(getIsWorkoutDone(a.category, a.completion_id)) -
            Number(getIsWorkoutDone(b.category, b.completion_id))
    );
